module.exports = __webpack_public_path__ + "img/bus-4.57c696b2.png";